

import React from 'react'

function Footer() {
  return (
    
    <>
      <footer className="footer">    
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="footer-py-60">
                            <div className="row">
                                <div className="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
                                    <a href="#" className="logo-footer">
                                        <img src="assets/images/mi-icon.png" height="24" alt="" />
                                    </a>
                                    <p className="mt-4">MINE INTELLECT</p>
                                    <ul className="list-unstyled social-icon foot-social-icon mb-0 mt-4">
                                        
                                        <li className="list-inline-item mb-0"><a href="/" target="_blank" className="rounded"><i className="uil uil-dribbble align-middle" title="dribbble"></i></a></li>
                                        <li className="list-inline-item mb-0"><a href="/" target="_blank" className="rounded"><i className="uil uil-facebook-f align-middle" title="facebook"></i></a></li>
                                        <li className="list-inline-item mb-0"><a href="/" target="_blank" className="rounded"><i className="uil uil-instagram align-middle" title="instagram"></i></a></li>
                                        <li className="list-inline-item mb-0"><a href="/" target="_blank" className="rounded"><i className="uil uil-twitter align-middle" title="twitter"></i></a></li>
                                    </ul>
                                </div>
                        
                                <div className="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                    <h5 className="footer-head">Байгууллага</h5>
                                    <ul className="list-unstyled footer-list mt-4">
                                        <li><a href="/about" className="text-foot"><i className="uil uil-angle-right-b me-1"></i> Бидний тухай</a></li>
                                        <li><a href="/service" className="text-foot"><i className="uil uil-angle-right-b me-1"></i> Үйл ажиллагаа</a></li>
                                        <li><a href="#" className="text-foot"><i className="uil uil-angle-right-b me-1"></i> Манай баг</a></li>
                                        <li><a href="#" className="text-foot"><i className="uil uil-angle-right-b me-1"></i> Үнийн санал</a></li>
                                        <li><a href="#" className="text-foot"><i className="uil uil-angle-right-b me-1"></i> Төслүүд</a></li>
                                        <li><a href="#" className="text-foot"><i className="uil uil-angle-right-b me-1"></i> Ажлын байр</a></li>
                                        <li><a href="#" className="text-foot"><i className="uil uil-angle-right-b me-1"></i> Мэдээ, мэдээлэл</a></li>
                                        <li><a href="/login" className="text-foot"><i className="uil uil-angle-right-b me-1"></i> Нэвтрэх</a></li>
                                    </ul>
                                </div>
                        
                                <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                    <h5 className="footer-head">Бусад</h5>
                                    <ul className="list-unstyled footer-list mt-4">
                                        <li><a href="#" className="text-foot"><i className="uil uil-angle-right-b me-1"></i> Компанийн дүрэм</a></li>
                                        <li><a href="#" className="text-foot"><i className="uil uil-angle-right-b me-1"></i> Заавар, зөвлөгөө</a></li>                                        
                                        <li><a href="#" className="text-foot"><i className="uil uil-angle-right-b me-1"></i> Санал, хүсэлт</a></li>
                                    </ul>
                                </div>
    
                               {/*  <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                                    <h5 className="footer-head">Санал хүсэлт</h5>
                                    <p className="mt-4">Sign up and receive the latest tips via email.</p>
                                    <form>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="foot-subscribe mb-3">
                                                    <label className="form-label">Write your email <span className="text-danger">*</span></label>
                                                    <div className="form-icon position-relative">
                                                        <i data-feather="mail" className="fea icon-sm icons"></i>
                                                        <input type="email" name="email" id="emailsubscribe" className="form-control ps-5 rounded" placeholder="Your email : " required />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="d-grid">
                                                    <input type="submit" id="submitsubscribe" name="send" className="btn btn-soft-primary" value="Subscribe" />
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-py-30 footer-bar">
                <div className="container text-center">
                    <div className="row align-items-center">
                        <div className="col-sm-6">
                            <div className="text-sm-start">
                                <p className="mb-0">© {new Date().getFullYear() } Mine Intellect LLC. </p>
                            </div>
                        </div>

                        
                    </div>
                </div>
            </div>
        </footer>

        <a href="#" id="back-to-top" className="back-to-top fs-5"><i data-feather="arrow-up" className="fea icon-sm icons align-middle"></i></a>
    </>
  )
}

export default Footer